export default __webpack_public_path__ + "static/media/PEN_Xmas2021_GiftGuide_Page_17.fc8c5f65.jpg";